<ng-template #drawerTemplate>
  <pxc-drawer />
</ng-template>
